export default "__VITE_ASSET__10c26c40__"